/**
 * Back to Top - Smooth scroll to top functionality
 */
(function() {
  const BackToTop = {
    $page: null,
    $trigger: null,

    cacheDom() {
      this.$page = document.querySelector('html, body');
      this.$trigger = document.querySelector('.js-back-to-top');
    },

    scrollToTop(event) {
      event.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },

    bindEvents() {
      if (this.$trigger) {
        this.$trigger.addEventListener('mousedown', this.scrollToTop.bind(this));
        this.$trigger.addEventListener('touchstart', this.scrollToTop.bind(this));
      }
    },

    init() {
      this.cacheDom();
      this.bindEvents();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => BackToTop.init());
  } else {
    BackToTop.init();
  }
})();